import { render, staticRenderFns } from "./AdminVerificationCalls.vue?vue&type=template&id=4a478556&scoped=true"
import script from "./AdminVerificationCalls.vue?vue&type=script&lang=js"
export * from "./AdminVerificationCalls.vue?vue&type=script&lang=js"
import style0 from "./AdminVerificationCalls.vue?vue&type=style&index=0&id=4a478556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a478556",
  null
  
)

export default component.exports